export default __webpack_public_path__ + "a7536b78ad781ffe47f3ee265bf884d9.png";